import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import PromoteursHeader from "./PromoteursHeader";
import moment from "moment";

const DiscussionList = () => {
  const { discussions } = useSelector((state) => state.discussionsReducer);
  const [searchfilter, setSearchfilter] = useState("");
  const [openedDiscussion, setOpenedDiscussion] = useState(null);
  const [filteredSortedDiscussions, setFilteredSortedDiscussions] = useState(
    []
  );
  const [sortField, setSortField] = useState("date");
  const [sortDirection, setSortDirection] = useState("asc");

  const handleSort = (field) => {
    if (field === sortField) {
      // Toggle direction
      setSortDirection((prev) => (prev === "asc" ? "desc" : "asc"));
    } else {
      setSortField(field);
      setSortDirection("asc");
    }
  };

  useEffect(() => {
    let filtered = discussions.filter((discussion) =>
      discussion.name.toLowerCase().includes(searchfilter.toLowerCase())
    );
    filtered = filtered.sort((a, b) => {
      let aValue = a[sortField];
      let bValue = b[sortField];

      if (typeof aValue === "string") aValue = aValue.toLowerCase();
      if (typeof bValue === "string") bValue = bValue.toLowerCase();

      if (aValue < bValue) return sortDirection === "asc" ? -1 : 1;
      if (aValue > bValue) return sortDirection === "asc" ? 1 : -1;
      return 0;
    });

    setFilteredSortedDiscussions(filtered);
  }, [discussions, searchfilter]);

  return (
    <div>
      <PromoteursHeader
        searchfilter={searchfilter}
        setSearchfilter={setSearchfilter}
        handleItemSearch={null}
        showButton={false}
      />
      <div className="bg-white bold d-flex radius05 my-2 p-3 pink ">
        <div className="w20 pointer" onClick={() => handleSort("createdAt")}>
          Date
        </div>
        <div className="flex-1 pointer" onClick={() => handleSort("name")}>
          Nom de la discussion
        </div>
        <div className="w10 pointer" onClick={() => handleSort("lastName")}>
          Nom
        </div>
        <div className="w10 pointer" onClick={() => handleSort("firstName")}>
          Prénom
        </div>
        <div className="w20 pointer" onClick={() => handleSort("email")}>
          Email
        </div>
        <div className="w10 pointer"></div>
      </div>
      <div className="d-flex gap-2 flex-column pointer">
        {filteredSortedDiscussions.map((discussion) => (
          <div key={discussion.id} className="bg-white">
            <div
              className="bold d-flex radius05 my-2 p-3"
              onClick={() =>
                setOpenedDiscussion(
                  discussion.id === openedDiscussion ? null : discussion.id
                )
              }
            >
              <div className="w20 pointer">
                {moment(discussion.createdAt).format("DD/MM/YYYY HH:mm:ss")}
              </div>
              <div className="flex-1 pointer">{discussion.name}</div>
              <div className="w10 pointer">{discussion.lastName}</div>
              <div className="w10 pointer">{discussion.firstName}</div>
              <div className="w20 pointer">{discussion.email}</div>
              <div className="w10 pointer d-flex justify-content-end t-02">
                <div
                  className="fs22"
                  style={{
                    transform:
                      openedDiscussion === discussion.id
                        ? "rotate(180deg)"
                        : "rotate(0deg)",
                  }}
                >
                  ▼
                </div>
              </div>
            </div>
            {openedDiscussion === discussion.id && (
              <div className="p-3 w100  d-flex flex-column border radius5">
                <div className="fs18 bold pink">Résumé de la discussion</div>
                <div
                  className="4 bold"
                  dangerouslySetInnerHTML={{ __html: discussion.description }}
                />
                <div className="fs18 bold mt-4 mb-2 pink">
                  Messages échangées
                </div>
                <div className="d-flex flex-column gap-4">
                  {discussion.messages.map((message) => (
                    <div
                      key={message.id}
                      className={`d-flex flex-column  w80 m-auto ${message.sender === "assistant"
                          ? "align-items-start"
                          : "align-items-end"
                        }`}
                    >
                      <div className="fs14 w50 ">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: `${message.text || ""} ${message.question ? "<br />" : ""
                              } ${message.question ? message.question : ""}`,
                          }}
                          className={`fs14 p-3 radius5 ${message.sender === "assistant"
                              ? "bg-pink text-white"
                              : "bg-blue text-white"
                            }`}
                        ></div>
                        <div className="fs14 d-flex justify-content-between mt-2">
                          <div>
                            {message.sender === "assistant"
                              ? "IA"
                              : "Utilisateur"}
                          </div>
                          <div>
                            {moment(message.createdAt).format(
                              "DD/MM/YYYY HH:mm:ss"
                            )}
                          </div>
                        </div>
                        {message.contact ? (
                          <div className="bold">
                            Ce message a affiché le bouton contact
                          </div>
                        ) : null}
                        {message.internet ? (
                          <div className="bold">
                            Ce message a nécessité une recherche sur internet
                          </div>
                        ) : null}
                        {message.db_search ? (
                          <div className="bold">
                            Ce message a nécessité une recherche dans la base de
                            données
                          </div>
                        ) : null}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default DiscussionList;
